import * as t from './actionTypes';
import { MetricsByOrganization, UsersByOrganization, InternalMetrics } from './types';

export function fetchInternalMetricsTable() {
  return {
    type: t.FETCH_INTERNAL_METRICS_REQUEST,
  };
}

export function receivedInternalMetrics(data: InternalMetrics) {
  return {
    type: t.RECEIVED_INTERNAL_METRICS,
    internalMetrics: data,
  };
}

export function fetchInternalMetricsError(error: Error) {
  return {
    type: t.FETCH_INTERNAL_METRICS_ERROR,
    error,
  };
}

export function fetchUsers() {
  return {
    type: t.FETCH_USERS_REQUEST,
  };
}

export function receivedUsers(data: UsersByOrganization[]) {
  return {
    type: t.RECEIVED_USERS,
    users: data,
  };
}

export function fetchUsersError(error: Error) {
  return {
    type: t.FETCH_USERS_ERROR,
    error,
  };
}

export function fetchMetricsByOrganization(data: MetricsByOrganization) {
  return {
    type: t.FETCH_METRICS_BY_ORGANIZATION_REQUEST,
    data,
  };
}

export function receivedOrganizationMetrics(data: MetricsByOrganization) {
  return {
    type: t.RECEIVED_ORGANIZATION_METRICS,
    organizationMetrics: data,
  };
}

export function fetchMetricsByOrganizationError(error: Error) {
  return {
    type: t.FETCH_METRICS_BY_ORGANIZATION_ERROR,
    error,
  };
}
